<script>
    import { onMount } from 'svelte';

    import model from '../../stores/modelStore';
    import { projectSettings } from '../../config';

    import PageSection from '../../components/PageSection.svelte';
    import Form from '../../components/Form.svelte';
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import ClassActionEmailAddress from '../../components/ClassActionEmailAddress.svelte';
    import ClassActionPhoneNumber from '../../components/ClassActionPhoneNumber.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';

    export let pageTitle = null;
    
	let buttons;

    document.title = pageTitle;

	const handleSubmit = async () => {
		buttons.blockNext();
		buttons.next();
		buttons.unblock();
	};

</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
        <FormRow class="justify-content-center confirmation-hide">
            <FormColumn>
                <h1 class="text-center">{@html projectSettings.classActionName}</h1>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn>
                <p>
                    Hello {$model.firstName} {$model.surname}.
                </p>
                <p>
                    To add files to your registration for the {@html projectSettings.classActionName} please click "UPLOAD FILES"
                </p>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center register-btn confirmation-hide">
            <FormColumn class="text-center">
                <NavigationButtons showPrevious={false}
                    bind:buttons
                    nextPageLabel='UPLOAD FILES'></NavigationButtons>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn>
                <p>
                    If you require support registering your interest, please contact Shine Lawyers on
                    <ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
                    <ClassActionEmailAddress></ClassActionEmailAddress>.
                </p>
            </FormColumn>
        </FormRow>
    </Form>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }
</style>


